import { render, staticRenderFns } from "./LayoutMain.vue?vue&type=template&id=2be8e0ca&"
var script = {}
import style0 from "./LayoutMain.vue?vue&type=style&index=0&scope=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports